import React, { useState } from "react";

import { Dialog, CloseButton, Button, Input, Portal } from "@chakra-ui/react";
import { showToast } from "../../../../../utilies/Utility";
import Type from "../../../../../utilies/Types";
import { loadGeojsonTypeAsync } from "../../../../../utilies/loader/LoadGeojson";
import { useAppStore } from "../../../../../context/store";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const LayersApprovalScanRoute = () => {
  // state
  const layersApprovalScanRouteDialog = useAppStore((s) => s.layersApprovalScanRouteDialog);
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);

  // setters / refs
  const setLayersApprovalScanRouteDialog = useAppStore.getState().setLayersApprovalScanRouteDialog;
  const viewerRef = useAppStore.getState().viewerRef;
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();
  const originalCameraControls = useAppStore.getState().originalCameraControls;

  const [layerName, setLayerName] = useState("Route");

  return (
    <Dialog.Root
      modal={false} // not modal
      open={layersApprovalScanRouteDialog ? true : false} // fix: true/false
      closeOnInteractOutside={false} // keep open until user acts
      // trapFocus={false}        // optional: if supported
    >
      {/* keep without backdrop */}
      <Portal>
        <Dialog.Positioner
          // pass clicks to underlying UI except dialog box itself

          style={{
            position: "fixed",
            inset: 0,
            pointerEvents: "none",
            zIndex: 9999,
          }}
        >
          <Dialog.Content
            // make dialog interactive again
            style={{ pointerEvents: "auto" }} // clicks captured only on box
          >
            <Dialog.Header>
              <Dialog.Title>Route Name</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Input
                placeholder="Enter layer name"
                value={layerName}
                onChange={(v) => setLayerName(v.target.value)} // keep it simple
              />
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button
                  variant="outline"
                  onClick={() => {
                    // close only
                    layersApprovalScanRouteDialog?.resetStyles();
                    setLayersApprovalScanRouteDialog(null); // close dialog
                  }}
                >
                  Cancel
                </Button>
              </Dialog.ActionTrigger>

              <Button
                onClick={() => {
                  // load layer
                  loadGeojsonTypeAsync({
                    originalCameraControls,
                    geojsonData: layersApprovalScanRouteDialog?.geojson,
                    fileName: layerName,
                    viewerRef,
                    setMapObjects,
                    defaultGeojsonStyle,
                    basicGeojsonStyle,
                    defaultOsmStyle,
                    isEdited: true,
                    zoomToDataSource: false,
                  });

                  // notify
                  showToast("Generate Route Mode Deactivated", Type.NOTIFICATION.INFO); // short info
                  showToast("Created Route Layer", Type.NOTIFICATION.SUCCESS); // success

                  // close
                  layersApprovalScanRouteDialog?.resetStyles();
                  setLayersApprovalScanRouteDialog(null); // close dialog
                }}
              >
                Save
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger
              asChild
              onClick={() => {
                layersApprovalScanRouteDialog?.resetStyles();
                setLayersApprovalScanRouteDialog(null); // close dialog
              }}
            >
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersApprovalScanRoute;
